import { ItemTypeMetadata } from "../item-type-metadata.enum"


export class WidgetJsonSchemaBase {

    type: string
    [name: string]: any

    constructor(itemType: ItemTypeMetadata | null) {
        if (itemType == null) {
            this.type = "string"
            return
        }

        switch (itemType) {
            
            case ItemTypeMetadata.Numeric:
                this.type = "number"
                return
            case ItemTypeMetadata.Text:
                this.type = "string"
                return
            case ItemTypeMetadata.CheckBox:
                this.type = "boolean"
                return
            case ItemTypeMetadata.MultiCheckBox:
                this.type = "object"
                return            
            case ItemTypeMetadata.Datepicker:
                this.type = "string"
                return                                    
            case ItemTypeMetadata.Time:
                this.type = "object"
                return                                    
            case ItemTypeMetadata.Radio:
                this.type = "string"
                return                                    
            case ItemTypeMetadata.Select:
                this.type = "string"
                return                                    
            case ItemTypeMetadata.TextArea:
                this.type = "string"
                return                                    

        }

        this.type="string" 
    }

}

export interface WidgetJsonSchema extends WidgetJsonSchemaBase { }